var $ = require('jquery');

web = window.web = window.web || {};

web.UrlStateCommiter = module.exports = function(options) {
    var t = this;
    t.instanceState = 'constructed';

    t.defaults = {
        anyDefaultOption: true
    };

    t.options = $.extend({}, t.defaults, options);
};

web.UrlStateCommiter.prototype = {
    init:  function(){
        var t = this;
        t.instanceState = 'inicialized';
    },

    commit: function(key, value){
        var t = this;

        t.commitState(key, value);
    },

    commitState: function(key, value) {
        var t = this;


        key = encodeURI(key);
        value = encodeURI(value);



        try {
            if (value!="null" && value!=null) {
                window.history.pushState('', '', t._updateQueryStringParameter(key, value));
            }
        } catch (e) {

        }
    },

    commitUrl: function(url) {
        var t = this;


        try {
            window.history.pushState('', '', url);
        } catch (e) {

        }
    },


    _updateQueryStringParameter: function(key, value, url) {
//        var uri = window.location.href;
//        var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
//        var separator = uri.indexOf('?') !== -1 ? "&" : "?";
//        if (uri.match(re)) {
//            return uri.replace(re, '$1' + key + "=" + value + '$2');
//        }
//        else {
//            return uri + separator + key + "=" + value;
//        }
        if (!url) url = window.location.href;
        var re = new RegExp("([?&])" + key + "=.*?(&|#|$)(.*)", "gi"),
            hash;

        if (re.test(url)) {
            if (typeof value !== 'undefined' && value !== null)
                return url.replace(re, '$1' + key + "=" + value + '$2$3');
            else {
                hash = url.split('#');
                url = hash[0].replace(re, '$1$3').replace(/(&|\?)$/, '');
                if (typeof hash[1] !== 'undefined' && hash[1] !== null)
                    url += '#' + hash[1];
                return url;
            }
        }
        else {
            if (typeof value !== 'undefined' && value !== null) {
                var separator = url.indexOf('?') !== -1 ? '&' : '?';
                hash = url.split('#');
                url = hash[0] + separator + key + '=' + value;
                if (typeof hash[1] !== 'undefined' && hash[1] !== null)
                    url += '#' + hash[1];
                return url;
            }
            else
                return url;
        }
    }



}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/web/UrlStateCommiter.js